import { useState } from "react";
import AscIcon from '../../../media/felsv/up-arrow-svgrepo-com.svg'
import DescIcon from '../../../media/felsv/down-arrow-svgrepo-com.svg'
import { useDispatch } from "react-redux";
import { generalOpenModalError } from "../../../actions/general.actions";

export default function FilterButton ({state, data, keyName} : {state: any, data: Array<any>, keyName: string}){
    const [order, setOrder] = useState('')
    const dispatch = useDispatch()
    const handleFilter = () => {
        try{
            const itemsOrdenados = [...data].sort((a,b) => {
                const valorA = String(a[keyName] || ''); // Convierte a[filterKey] en una cadena
                const valorB = String(b[keyName] || ''); // Convierte b[filterKey] en una cadena
                let comparacion
                if(parseFloat(valorA) && parseFloat(valorB)){
                    comparacion = parseFloat(valorA) - parseFloat(valorB)
                } else {
                    comparacion = valorA.localeCompare(valorB);
                }
                if(!order || order === 'desc'){
                    return comparacion
                } else {
                    return -comparacion
                }
        })
        if(!order || order === 'desc'){
            setOrder('asc')
        } else {
            setOrder('desc')
        }
        state(itemsOrdenados)
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al ordenar los items de la tabla.'))
        }
    }

    return (
        <button onClick={handleFilter}>
                <img style={{width: '12px'}} src={(!order || order === 'asc') ? AscIcon : DescIcon}/>
        </button>
    )
}